import script from "./UserMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMapping.vue?vue&type=script&setup=true&lang=js"

import "./UserMapping.vue?vue&type=style&index=0&id=1617ad80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1617ad80"]])

export default __exports__